// src/components/CustomNode.jsx
import React from 'react';
import { Handle } from 'reactflow';

export default function CustomNode({ data }) {
  const isSpecial = ["ELO", "STOP", "RETURN"].includes(data.type);

  // Texto especial
  let specialText = "";
  if (isSpecial) {
    if (data.type === "ELO") {
      specialText = (data.destino && data.retorno)
        ? `${data.destino} - ${data.retorno}`
        : (data.destino || "ELO");
    } else if (data.type === "STOP") {
      specialText = "STOP";
    } else {
      specialText = "RETURN";
    }
  }

  const estiloTexto = {
    fontSize: isSpecial ? 12 : 10,
    fontWeight: isSpecial ? "700" : "normal",
    color:
      data.type === "ELO" ? "#1a237e" :
      data.type === "STOP" ? "#b71c1c" :
      data.type === "RETURN" ? "#33691e" :
      "#000",
    textAlign: "center",
    lineHeight: 1.1,
    wordBreak: "break-word",
  };

  return (
    <div>
      <div style={estiloTexto}>
        {isSpecial
          ? specialText
          : (React.isValidElement(data.label) ? data.label : (data.label || ""))}
      </div>

      <Handle type="target" position="top" id="a" />
      {!isSpecial && <Handle type="source" position="bottom" id="b" />}
    </div>
  );
}
